<template>
  <div class="main">

    <slide-in-panel />
    <div class="navbar">
      <div class="logo">
        <img class="image" alt="CAnnect logo" src="@/assets/CAnnectLogo.svg" @click="goToHome" />
        <img class="logo-indosuez" alt="logo CA Indosuez Wealth Management" src="@/assets/logo-indosuez.svg" />
      </div>
      <ul class="content" data-cy="navbar-links">
        <li class="item">
          <span data-cy="home-button" @click="goToHome" class="tab-button"
            :class="activeRoute.name === 'homePage' ? 'active' : ''">
            <HomeIcon />
            <span class="text">{{ $t('navbar.home') }}</span>
          </span>
        </li>
        <li data-cy="navbar-communities" class="item">
          <span class="tab-button" @click="goToCommunities"
            :class="['communityPage', 'communitiesPage'].includes(activeRoute.name) ? 'active' : ''">
            <GroupIcon />
            <span class="text"> {{ $t('navbar.communities') }}</span>
          </span>
        </li>
        <li v-if="isAdministrator" class="item">
          <span class="tab-button" @click="goToAdministrator" :class="isAdminRoute ? 'active' : ''">
            <SecurityIcon />
            <span class="text">{{ $t('navbar.administrator') }}</span>
            <span class="bubble-number reported-count">{{ reportedContentNumber }}</span>
          </span>
        </li>
        <li v-if="isAdministrator" class="item">
          <span class="tab-button" @click="goToDashboard" :class="'dashboardPage' === activeRoute.name ? 'active' : ''">
            <DashboardIcon />
            <span class="text"> {{ $t('navbar.dashboard') }}</span>
          </span>
        </li>
      </ul>
      <div class="submenu-container">
        <SubMenu />
      </div>
    </div>
    <Konami />
    <!--<SecurityReminder />-->
    <filter-bar />
    <maintenance-banner />
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import FilterBar from './filter/FilterBar'
import SlideInPanel from '@/components/notification/SlideInPanel'
import MaintenanceBanner from '@/components/shared/MaintenanceBanner'
import { mapState } from 'vuex'
import Konami from './shared/Konami'
import SubMenu from '@/components/submenu/SubMenu.vue'
import GroupIcon from 'vue-material-design-icons/AccountMultipleOutline.vue'
import HomeIcon from 'vue-material-design-icons/HomeOutline.vue'
import SecurityIcon from 'vue-material-design-icons/Security.vue'
import DashboardIcon from 'vue-material-design-icons/MonitorDashboard.vue'

export default {
  name: 'Navbar',
  components: { MaintenanceBanner, SubMenu, SecurityIcon, HomeIcon, GroupIcon, DashboardIcon, FilterBar, SlideInPanel, Konami },
  directives: {
    ClickOutside
  },
  data() {
    return {
      showMenu: false
    }
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    hideMenu() {
      this.showMenu = false
    },
    changeLanguage(val) {
      this.$i18n.locale = val
      this.$store.dispatch('changeLocale', val)
    },
    goToHome() {
      !window.location.pathname.includes('home') && this.$router.push({ name: 'homePage' })
    },
    goToAdministrator() {
      !window.location.pathname.includes('administrator') && this.$router.push({ name: 'administratorPage' })
    },
    goToDashboard() {
      !window.location.pathname.includes('dashboard') && this.$router.push({ name: 'dashboardPage' })
    },
    goToCommunities() {
      !window.location.pathname.includes('communities') && this.$router.push({ name: 'communitiesPage' })
    },
    showHidePanel(panelType) {
      this.$store.dispatch('showHidePanel', panelType)
      if (panelType === 'NOTIF') {
        this.$store.dispatch('seeNewNotifications')
      }
    },
    notifNumber(count) {
      if (count === 0) {
        return
      } else if (count > 99) {
        return '99+'
      }
      return count
    }
  },
  computed: {
    languageList() {
      return this.$i18n.availableLocales.filter(l => this.$i18n.locale !== l)
    },
    isAdministrator() {
      return this.$store.getters.auth.isAdmin
    },
    notificationsNumber() {
      return this.notifNumber(this.newNotificationsNumber)
    },
    reportedContentNumber() {
      return this.notifNumber(this.reportedContentCount)
    },
    isAdminRoute() {
      return this.$store.getters.isAdminRoute
    },
    ...mapState({
      activeRoute: (state) => state.route.activeRoute,
      newNotificationsNumber: (state) => state.user.user.newNotificationsNumber,
      reportedContentCount: (state) => state.user.reportedContentCount
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.main {
  display: flex;
  flex-direction: column;
  background-image: linear-gradient(0deg, #ffffff 0%, #f2f2f2 100%);
  box-shadow: 0 2px 8px 0 rgba(69, 69, 69, 0.16);
  min-height: 110px;
  height: auto;
  position: fixed;
  width: 100%;
  z-index: 3;

  @media (max-width: $medium) {
    max-height: none !important;
    height: auto;
  }
}

.navbar {
  width: calc(100vw - 10px);
  //overflow: hidden;
  overflow-x: clip;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  font-weight: bold;
  height: 84px;
  margin-top: 0.5rem;
  margin-bottom: -10px;

  @media (max-width: $medium) {
    height: 50px;
    margin-bottom: 5px;
  }

  @media (max-width: $header-change) {
    justify-content: center;
  }

  .submenu-container {
    justify-content: flex-end;
    display: flex;
  }

  .logo {
    cursor: pointer;
    height: 70px;
    flex: none;
    width: 25vw;

    @media (max-width: $medium) {
      height: 50px;
    }

    img {
      height: 100%;
      max-width: 19rem;
    }

    img+img {
      margin-left: 2rem;
    }
  }

  .content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    list-style: none;
    padding: 0;
    margin-top: 0;

    @media (max-width: $header-change) {

      min-width: 40%;
    }

    @media (max-width: $medium) {
      align-content: center;
      margin-top: 0;
      margin-bottom: 0;
      height: 100%;
      display: flex;
    }

    .item {
      display: flex;
      min-width: 5rem;
      padding: 0 16px;

      @media (max-width: $medium) {
        padding: 0;
      }

      @media (max-width: $small) {
        margin: 0;
        min-width: auto;
        padding: 0;
      }

      .homepage {
        width: 82px;
      }

      .tab-button {
        width: 100%;
        align-items: center;
        display: grid;

        span {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        @include ease-in-out-transition;
        text-decoration: none;
        color: #999999;
        font-weight: 700;
        border-radius: 21px;
        padding: 3px 15px;
        cursor: pointer;

        @media (max-width: $medium) {
          margin: 0 0.2rem;
          min-width: 2rem;
          max-width: 50px;

          .text {
            display: none;
            transition: opacity 0.3s ease-in-out;
          }
        }

        @media (max-width: $small) {
          margin: 0 0.1rem;
          min-width: 1rem;
          max-width: 50px;
        }

        .text {
          vertical-align: top;

          font-family: 'Barlow', Arial, 'Open Sans', normal, sans-serif;

        }

        &.active {

          @include ease-in-out-transition;
          border-radius: 50px;
          padding: 3px 16px;
          color: #ffffff;

          background-color: $secondary-color;
          animation-duration: 3s;
          animation-name: slidein;
        }

        &:hover:not(.active) {
          color: $secondary-color;
        }
      }
    }
  }

}

.logo {
  @media (max-width: $header-change) {
    transition: height 0.5s ease;
    position: fixed;
    bottom: 0;
    left: 0.2rem;
    z-index: 10;
    max-width: calc(20vw - 0.2rem);
    height: 40px !important;

    .image {
      margin-top: 5px;
      height: calc(100% - 10px) !important;
      width: calc(100% - 10px);
    }

    .logo-indosuez {
      display: none;
    }
  }

  @media (max-width: $tiny) {
    height: 30px !important;
  }
}
</style>
